module.exports = __webpack_public_path__ + "static/img/cabinet12_11.b64534e7.gif";